import React from 'react';

import { Button } from 'antd';

const Submit = ({children, icon, actionDisable, loading, style}) => (
    <Button style={style || {}} type="primary" loading={loading} icon={icon || ''} htmlType="submit" disabled={actionDisable} >{children}</Button>
);


export default Submit;